import { render, staticRenderFns } from "./SummaryTabsButtons.vue?vue&type=template&id=48ef7f0c&scoped=true"
import script from "./SummaryTabsButtons.vue?vue&type=script&lang=js"
export * from "./SummaryTabsButtons.vue?vue&type=script&lang=js"
import style0 from "./SummaryTabsButtons.vue?vue&type=style&index=0&id=48ef7f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef7f0c",
  null
  
)

export default component.exports